import { render } from "./NotificationMenu.vue?vue&type=template&id=aa577286&scoped=true"
import script from "./NotificationMenu.vue?vue&type=script&lang=js"
export * from "./NotificationMenu.vue?vue&type=script&lang=js"

import "./NotificationMenu.vue?vue&type=style&index=0&id=aa577286&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa577286"]])

export default __exports__